const generateSrcset = (image, widths = []) => {
  const imageUrl = new URL(image["src"]);
  return widths
    .filter((width) => width <= image["width"])
    .map((width) => {
      imageUrl.searchParams.set("width", width.toString());
      return `${imageUrl.href} ${width}w`;
    })
    .join(", ");
};

const createImageElement = (image, classes, sizes, productTitle) => {
  const previewImage = image["preview_image"];
  const newImage = new Image(previewImage["width"], previewImage["height"]);
  newImage.className = classes;
  newImage.alt = image["alt"] || productTitle;
  newImage.sizes = sizes;
  newImage.src = previewImage["src"];
  newImage.srcset = generateSrcset(
    previewImage,
    [165, 360, 533, 720, 940, 1066]
  );
  newImage.loading = "lazy";
  return newImage;
};

const initializedSwatches = new WeakSet();

const checkSwatches = (parent = document) => {
  parent.querySelectorAll(".js-color-swatches-wrapper").forEach((wrapper) => {
    wrapper.querySelectorAll(".js-color-swatches input").forEach((input) => {
      if (initializedSwatches.has(input)) return;
      initializedSwatches.add(input);
      input.addEventListener("click", (event) => {
        const primaryImage = wrapper.querySelector(".media--first");
        const secondaryImage = wrapper.querySelector(".media--second");
        const handleProduct = wrapper.dataset.product;

        if (event.currentTarget.checked) {
          const cardState = wrapper.querySelector(
            `template[data-card-option-value-id="${event.currentTarget.dataset.optionValueId}"]`
          );
          if (cardState) {
            const status = wrapper.querySelector("[data-card-status]");
            const nextStatus = cardState.content.querySelector("[data-card-status]");
            if (status && nextStatus) status.innerHTML = nextStatus.innerHTML;
            const price = wrapper.querySelector(".price");
            const nextPrice = cardState.content.querySelector(".price");
            if (price && nextPrice) price.replaceWith(nextPrice.cloneNode(true));
            else if (price) price.hidden = true;
          }
          const variantLink = event.currentTarget.dataset.variantLink;
          const swatchesLink = wrapper.querySelector(".js-color-swatches-link");
          if (variantLink && swatchesLink) {
            swatchesLink.setAttribute("href", variantLink);
          }

          const addButton = wrapper.querySelector(
            '.card__add-to-cart button[name="add"]'
          );
          if (addButton) {
            const phase = addButton.closest("form")?.dataset.cbsProductPhase;
            const phaseBlocked = phase === "coming-soon" || phase === "invalid";
            const unavailable = phaseBlocked ||
              (cardState
                ? cardState.dataset.available !== "true"
                : event.currentTarget.classList.contains("disabled")) ||
              !event.currentTarget.dataset.variantId;
            addButton.disabled = unavailable;
            addButton.setAttribute("aria-disabled", String(unavailable));
            addButton
              .querySelector(".card__quickview-text")
              ?.classList.toggle("hidden", unavailable && !phaseBlocked);
            addButton
              .querySelector(".sold-out-message")
              ?.classList.toggle("hidden", !unavailable || phaseBlocked);
            wrapper.querySelector('.card__add-to-cart input[name="id"]').value =
              event.currentTarget.dataset.variantId;
          }

          if (!primaryImage) return;

          const currentColor = event.currentTarget.value;

          jQuery.getJSON(
            window.Shopify.routes.root + `products/${handleProduct}.js`,
            function (product) {
              const variant = product.variants.filter(
                (item) =>
                  item.featured_media != null &&
                  item.options.includes(currentColor)
              )[0];

              if (variant) {
                const newPrimaryImage = createImageElement(
                  variant["featured_media"],
                  primaryImage.className,
                  primaryImage.sizes,
                  product.title
                );

                if (newPrimaryImage.src !== primaryImage.src) {
                  let flag = false;
                  if (secondaryImage) {
                    const secondaryImagePathname = new URL(secondaryImage.src)
                      .pathname;
                    const newPrimaryImagePathname = new URL(newPrimaryImage.src)
                      .pathname;

                    if (secondaryImagePathname == newPrimaryImagePathname) {
                      primaryImage.remove();
                      secondaryImage.classList.remove("media--second");
                      secondaryImage.classList.add("media--first");
                      flag = true;
                    }
                  }
                  if (flag == false) {
                    primaryImage.animate(
                      { opacity: [1, 0] },
                      { duration: 200, easing: "ease-in", fill: "forwards" }
                    ).finished;
                    setTimeout(function () {
                      primaryImage.replaceWith(newPrimaryImage);
                      newPrimaryImage.animate(
                        { opacity: [0, 1] },
                        { duration: 200, easing: "ease-in" }
                      );
                      if (secondaryImage) {
                        secondaryImage.remove();
                      }
                    }, 200);
                  }
                }
              }
            }
          );
        }
      });
    });
  });
};

function colorSwatches() {
  checkSwatches();

  document.addEventListener("shopify:section:load", function (event) {
    checkSwatches(event.target);
  });
  document.addEventListener("products-grid:loaded", (event) => checkSwatches(event.target));
}

const initializedSpecsToggles = new WeakSet();
const initializedSpecsCards = new WeakSet();

function setSpecsState(wrapper, active) {
  wrapper.classList.toggle("is-active", active);
  wrapper.querySelector(".specs_closed")?.setAttribute("aria-expanded", String(active));
  wrapper.querySelector(".specs_opened")?.setAttribute("aria-expanded", String(active));
}

function productCardSpecs(parent = document) {
  const toggles = parent.querySelectorAll(".js-toggle-specs");

  toggles.forEach((wrapper) => {
    if (initializedSpecsToggles.has(wrapper)) return;
    initializedSpecsToggles.add(wrapper);
    const openBtn = wrapper.querySelector(".specs_closed");
    const closeBtn = wrapper.querySelector(".specs_opened");

    openBtn.addEventListener("mouseenter", () => {
      setSpecsState(wrapper, true);
    });

    openBtn?.addEventListener("click", (e) => {
      e.stopPropagation();
      setSpecsState(wrapper, true);
    });

    closeBtn?.addEventListener("click", (e) => {
      e.stopPropagation();
      setSpecsState(wrapper, false);
    });

    [openBtn, closeBtn].forEach((button, index) => {
      button?.addEventListener("keydown", (event) => {
        if (event.key !== "Enter" && event.key !== " ") return;
        event.preventDefault();
        button.click();
        (index === 0 ? closeBtn : openBtn)?.focus();
      });
    });
  });

  const cardWrappers = parent.querySelectorAll(".product_card_specs");

  cardWrappers.forEach((wrapper) => {
    if (initializedSpecsCards.has(wrapper)) return;
    initializedSpecsCards.add(wrapper);
    const jsToggleSpecs = wrapper.querySelector(".js-toggle-specs");

    wrapper.addEventListener("mouseleave", (e) => {
      const toElement = e.relatedTarget;

      if (toElement && toElement.closest(".swiper-buttons__wrapper")) {
        return;
      }

      if (jsToggleSpecs) {
        setSpecsState(jsToggleSpecs, false);
      }
    });
  });
}

function renderProductCardSpecs() {
  productCardSpecs();

  document.addEventListener("shopify:section:load", function (event) {
    productCardSpecs(event.target);
  });
  document.addEventListener("products-grid:loaded", (event) => productCardSpecs(event.target));
}

(function () {
  colorSwatches();
  renderProductCardSpecs();
})();
